module.exports = __webpack_public_path__ + "img/kaia.777bd58a.svg";